import styled, { css } from "styled-components";
import theme from "theme";

export const PageLayoutStyled = styled("div")<{ isFullScreenLayout: boolean }>`
    ${({ isFullScreenLayout }) =>
        isFullScreenLayout &&
        css`
            display: flex;
            grid-template-areas:
                "header header"
                "sidenav  main";
            grid-template-rows: auto 1fr;
            grid-template-columns: auto 1fr;
            grid-row-gap: 7rem;
            background: var(--b-wf-9-f-9-f-9, #f9f9f9);
            min-height: 100vh;
            padding-bottom: 2rem;
            padding-top:6rem;
            /* padding-top: 2rem; */

            @media (${theme.breakpoints.mobileL}) {
                grid-template-areas:
                    "sidenav"
                    "main";
                grid-template-rows: auto 1fr;
                grid-row-gap: 2rem;
            }
        `};
`;
